export default __webpack_public_path__ + "static/media/question-circle-lg-red.a7611940.svg";